import { CodedError } from './CodedError';
import { errorCodes } from './constants/errorCodes';

export class EventContentInvalidDateRangeError extends CodedError {
  static get errorName() {
    return errorCodes.eventContentInvalidDateRangeError.code;
  }

  constructor(
    message: string = errorCodes.eventContentInvalidDateRangeError.message
  ) {
    super(message);
    this.code = errorCodes.eventContentInvalidDateRangeError.code;
    this.message = `${message} ${errorCodes.eventContentInvalidDateRangeError.code}`;
    this.name = errorCodes.eventContentInvalidDateRangeError.name;
  }
}
